/**
 * 车辆信息实体
 * zxw
 * 创建时间：
 * 修改时间：2026-07-08
*/

import { useState, useEffect } from 'react';
import {
    Modal,
    Input,
    Row,
    Col,
    message,
    InputNumber,
    Select,
    DatePicker,
    Flex,
    Typography,
} from 'antd';
import $ from 'jquery';
import {
    AddRequestHeaders,
    UjoinParams,
    currentDate,
} from '../../incs/FunHelper';
import CNF from '../../incs/Config';

/** 
* 日期样式
*/
import dayjs from 'dayjs';
const MODULENAME = '车辆信息';
const { Text } = Typography;

const { TextArea } = Input;

const MODULENAME_URL = CNF.navItems[1].submenu[0].url;

const Entity = (props) => {
    const { open, setOpen, record, refresh } = props;

    const [messageApi, contextHolder] = message.useMessage();

    const [loading, setLoading] = useState(false);
    const [licenseNumber, setLicenseNumber] = useState('');
    const [purchaseTime, setPurchaseTime] = useState(currentDate);
    const [name, setName] = useState('');
    const [model, setModel] = useState('');
    const [currentMileage, setCurrentMileage] = useState(1);
    const [username, setUsername] = useState('');
    const [displayname, setDisplayname] = useState('');
    const [uses, setUses] = useState('');
    const [description, setDescription] = useState('');

    const [personnelLists, setPersonnelLists] = useState([]);

    const cancel = () => {
        setOpen(false, null);
        setLoading(false);
        setLicenseNumber('');
        setPurchaseTime(currentDate);
        setName('');
        setModel('');
        setCurrentMileage(1);
        setUsername('');
        setDisplayname('');
        setUses('');
        setDescription('');
    };

    useEffect(() => {
        // 修改初始化
        if (record) {
            setLicenseNumber(record.license_number);
            setPurchaseTime(record.purchase_time);
            setName(record.name);
            setModel(record.model);
            setCurrentMileage(record.current_mileage);
            setUsername(record.driver_username);
            setDisplayname(record.driver_displayname);
            setUses(record.uses);
            setDescription(record.description);
        }
    }, [record]);


    useEffect(() => {
        const params = {
            rss: 'list',
            page_size: CNF.maxPageSize,
            current_index: 1
        };
        $.ajax({
            url: `${CNF.sealApi}users${UjoinParams(params)}`,
            headers: AddRequestHeaders(),
            crossDomain: true,
            type: 'GET',
        }).done((data) => {
            if (data.res === 0) {
                setPersonnelLists(data.dat);
            } else {
                setPersonnelLists([])
            }
        })
    }, [])


    const ok = () => {
        //  参数校验
        if (!licenseNumber) {
            messageApi.error('车牌号码不能为空！');
            return;
        }
        if (!name) {
            messageApi.error('车辆名称不能为空！');
            return;
        }
        setLoading(true);

        //  执行创建
        $.ajax({
            url: CNF.api + MODULENAME_URL.slice(1) + (record ? '/' + record.key : ''),
            headers: AddRequestHeaders(),
            type: record ? 'PUT' : 'POST',
            dataType: 'JSON',
            data: JSON.stringify({
                license_number: licenseNumber,
                name: name,
                model: model,
                driver_username: username,
                driver_displayname: displayname,
                uses: uses,
                purchase_time: purchaseTime,
                current_mileage: currentMileage,
                description: description
            }),
        }).done(function (data) {
            if (data.res === 0) {
                messageApi.success(data.msg, CNF.messageDuration);
                setTimeout(function () {
                    cancel();
                    refresh();
                }, CNF.messageDuration * 1000);
            } else {
                messageApi.error(data.msg, CNF.messageDuration);
            }
        }).fail(function (err) {
            messageApi.error(err.responseJSON?.detail || '请求失败', CNF.messageDuration);
        }).always(() => setTimeout(function () {
            setLoading(false)
        }, CNF.messageDuration * 1000))

    };


    return (
        <>
            {contextHolder}
            <Modal
                style={{ top: 0 }}
                width={600}
                title={(record ? CNF.actionName.UPDATE : CNF.actionName.CREATE) + MODULENAME}
                open={open}
                onOk={ok}
                onCancel={cancel}
                keyboard={true}
                okText='确认'
                cancelText='取消'
                okButtonProps={{ disabled: loading }}
            >
                <Flex vertical gap='small'>
                    <Row>
                        <Col span={11}><Text>车牌号码</Text><Text type='danger'>*</Text></Col>
                        <Col span={11} offset={2}><Text>车辆名称</Text><Text type='danger'>*</Text></Col>
                        <Col span={11}>
                            <Input
                                placeholder='请输入'
                                value={licenseNumber}
                                onChange={(e) => setLicenseNumber(e.target.value)}
                                disabled={record ? true : loading}
                            />
                        </Col>
                        <Col span={11} offset={2}>
                            <Input
                                placeholder='请输入'
                                value={name}
                                onChange={(e) => setName(e.target.value)}
                                disabled={loading}
                            />
                        </Col>
                    </Row>
                    <Row>
                        <Col span={11}><Text>车辆型号</Text></Col>
                        <Col span={11} offset={2}><Text>购买时间</Text></Col>
                        <Col span={11}>
                            <Input
                                placeholder='请输入'
                                value={model}
                                onChange={(e) => setModel(e.target.value)}
                                disabled={loading}
                            />
                        </Col>
                        <Col span={11} offset={2}>
                            <DatePicker
                                placeholder='请选择日期'
                                style={{ width: '100%' }}
                                value={dayjs(purchaseTime, 'YYYY-MM-DD')}
                                onChange={(_, dateString) => setPurchaseTime(dateString)}
                                disabled={loading}
                            /></Col>
                    </Row>
                    <Row>
                        <Col span={11}><Text>驾驶人员</Text></Col>
                        <Col span={11} offset={2}><Text>当前里程</Text></Col>
                        <Col span={11}>
                            <Select
                                showSearch
                                placeholder='请选择'
                                style={{ width: '100%' }}
                                value={displayname || undefined}
                                onChange={(value, option) => {
                                    setUsername(value);
                                    setDisplayname(option?.label || '');
                                }}
                                disabled={loading}
                                filterOption={(input, option) => option.props.children.indexOf(input) >= 0}
                                options={personnelLists && personnelLists.map((item, index) => ({
                                    key: index,
                                    value: item.username,
                                    label: item.displayname,
                                }))}
                            />
                        </Col>
                        <Col span={11} offset={2}>
                            <InputNumber
                                suffix='km'
                                min={1}
                                step={1}
                                style={{ width: '100%' }}
                                onChange={(value) => setCurrentMileage(value)}
                                value={currentMileage}
                                disabled={props.record ? true : loading}
                            />
                        </Col>
                    </Row>
                    <Row>
                        <Col span={24}>车辆用途</Col>
                        <Col span={24}>
                            <Input
                                placeholder='请输入'
                                value={uses}
                                onChange={(e) => setUses(e.target.value)}
                                disabled={loading}
                            />
                        </Col>
                    </Row>
                    <Row>
                        <Col span={24}>车辆备注</Col>
                        <Col span={24}>
                            <TextArea
                                placeholder='请输入'
                                rows={2}
                                autoSize={{ minRows: 3, maxRows: 12 }}
                                value={description}
                                onChange={(e) => setDescription(e.target.value)}
                                disabled={loading}
                            />
                        </Col>
                    </Row>
                </Flex>
            </Modal>
        </>
    );
}

export default Entity